import { render, staticRenderFns } from "./COrderList.vue?vue&type=template&id=08d4d042&scoped=true"
import script from "./COrderList.vue?vue&type=script&lang=ts"
export * from "./COrderList.vue?vue&type=script&lang=ts"
import style0 from "./COrderList.vue?vue&type=style&index=0&id=08d4d042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4d042",
  null
  
)

export default component.exports